import { AppLayout } from "@/components/layout/AppLayout";
import { useParams } from "react-router-dom";

const pages: Record<string, { title: string; subtitle: string }> = {
  underperforming: { title: "Underperforming Vehicles", subtitle: "Identify vehicles that need attention based on performance trends." },
  comparisons: { title: "Vehicle Comparisons", subtitle: "Compare vehicles side-by-side to inform fleet decisions." },
  profit: { title: "Profit Improvement Opportunities", subtitle: "Discover ranked opportunities to increase profitability." },
  attention: { title: "Attention Required", subtitle: "See where your attention will have the biggest impact." },
  risk: { title: "What Could Go Wrong?", subtitle: "Surface silent risks and historical patterns before they become costly." },
  alerts: { title: "Alerts & Exceptions", subtitle: "Monitor anomalies and operational exceptions across your fleet." },
};

const DecisionPlaceholder = () => {
  const { type } = useParams<{ type: string }>();
  const page = pages[type || ""];
  const title = page?.title || "Decisions";
  const subtitle = page?.subtitle || "";

  return (
    <AppLayout>
      <div className="p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        <p className="text-muted-foreground">This section is coming soon.</p>
      </div>
    </AppLayout>
  );
};

export default DecisionPlaceholder;
